module.exports = __webpack_public_path__ + "pc/media/emotion_video 2.7e5917e4.mp4";